<div *ngIf="hasError">
  <alert type="danger" translate>
    An error has occurred. {{errorMessage}}
    <button type="button" class="close" data-dismiss="alert">
      <span>&times;</span>
    </button>
  </alert>
</div>
<ap-alert></ap-alert>
<div>
    <ap-message-editor [baseId]="Id"
                       [readOnly]="readOnly"
                       [showButtons]="showButtons"
                       [sendCallback]="onSend"
                       [completeCallback]="onComplete"
                       [(urgencyId)]="urgencyId"
                       [clearMessageOnSend]="reloadOnSend"
                       (urgencyIdChange)="onMessageUrgencyChange($event)"
                       [(dueDate)]="dueDate"
                       (dueDateChange)="onMessageDueDateChange($event)"
                       (editComplete)="onEditComplete($event)"></ap-message-editor>

  <div class="text-center" *ngIf="loading">
    <ap-spinner size="3"></ap-spinner>
  </div>
  <div *ngIf="!loading">
      <ap-message-thread [baseId]="Id" [messageThread]="messageThread"></ap-message-thread>
  </div>
</div>
